import { connect } from 'react-redux';
import BackButton from 'components/BackButton';
import { startGoBack } from 'routes/reducer';
import { push } from 'react-router-redux';

function mapDispatchToProps(dispatch) {
  return {
    navigateBack: url => {
      dispatch(startGoBack());
      dispatch(
        push({
          pathname: url,
          state: {
            transitionDirection: 'back'
          }
        })
      );
    }
  };
}

export default connect(null, mapDispatchToProps)(BackButton);
